// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.promoRow[data-v-23c46fc5] {\n  height: 60px;\n}\n.active[data-v-23c46fc5] {\n  background: #fff;\n  color: #37474F !important;\n}\n.returnLink[data-v-23c46fc5] {\n  text-decoration:none; \n  color: var(--v-primary-base);\n}\n", ""]);
// Exports
module.exports = exports;
